import { trackEvent } from "@/lib/client/analytics";

export const sendGtagEvent = (
  action: string,
  category: string,
  label: string,
  other?: { [key: string]: string }
) => {
  if (typeof window !== "undefined" && window.gtag) {
    window?.gtag("event", action, {
      event_category: category,
      event_action: action,
      event_label: label,
      ...(other || {}),
    });
  }

  // Mirror to internal analytics — wrapped in try/catch so a failure
  // here can never break existing GA4 event tracking
  try {
    const eventCategory =
      category === "search" || category === "filter_menu"
        ? "search"
        : category === "outbound"
          ? "engagement"
          : category === "navigation"
            ? "navigation"
            : "engagement";

    trackEvent(
      `${action}_${category}`,
      eventCategory as "search" | "engagement" | "navigation" | "session" | "error",
      { action, category, label, ...(other || {}) }
    );
  } catch {
    // Silently drop — internal analytics must never affect GA4 tracking
  }
};
